import React from "react"
import Select from "react-select"

const CustomSingleSelect = ({
  name,
  value,
  onChange,
  options,
  placeholder,
  isDisabled = false,
  isInvalid = false,
  onBlur,
  styles,
}) => {
  return (
    <Select
      name={name}
      value={value}
      isMulti={false}
      onChange={onChange}
      options={options}
      onBlur={onBlur}
      className={`react-select-container ${isInvalid ? "invalid" : ""}`}
      placeholder={placeholder}
      isDisabled={isDisabled}
      isClearable
      styles={styles}
    />
  )
}

export default CustomSingleSelect
